import { useState } from 'react';
import { api } from '../lib/api.js';

// ─── Dispute Alerts Modal ─────────────────────────────────────────────────────
export function DisputeAlertsModal({ user, alerts, onDismiss, onClose }) {
  const [dismissing, setDismissing] = useState(null);

  async function handleDismiss(alertId) {
    setDismissing(alertId);
    try {
      await api('PUT', `/api/disputes/${alertId}/dismiss`, { user_id: user.id });
      onDismiss(alertId);
    } finally { setDismissing(null); }
  }

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={onClose}>
      <div className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl flex flex-col fade-in shadow-2xl max-h-[85vh]" onClick={e => e.stopPropagation()}>
        <div className="bg-amber-600 rounded-t-2xl p-5 flex items-center justify-between flex-shrink-0">
          <div>
            <p className="text-amber-100 text-xs uppercase tracking-wider mb-0.5">Task Reviews</p>
            <h3 className="text-white font-bold text-base">Issues Filed Against Your Work</h3>
          </div>
          <button onClick={onClose} className="text-white/60 hover:text-white text-3xl leading-none ml-4">×</button>
        </div>
        <div className="overflow-y-auto flex-1 p-4 space-y-3">
          <p className="text-xs text-gray-500 mb-2">Review each issue and dismiss when you've addressed it. The reporter is anonymous.</p>
          {alerts.map(alert => (
            <div key={alert.id} className="bg-amber-50 border border-amber-200 rounded-xl p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm text-ink mb-1">{alert.task_title}</p>
                  <p className="text-sm text-gray-700 mb-2">{alert.description}</p>
                  <p className="text-xs text-gray-400">
                    {alert.completion_date && `Completed: ${alert.completion_date} · `}
                    Filed: {new Date(alert.flagged_at).toLocaleDateString()}
                  </p>
                  {alert.photo_url && (
                    <img src={alert.photo_url} alt="Evidence" className="mt-2 w-20 h-16 object-cover rounded-lg border border-gray-200 cursor-pointer" onClick={() => window.open(alert.photo_url)} />
                  )}
                </div>
                <button onClick={() => handleDismiss(alert.id)} disabled={dismissing === alert.id}
                  className="flex-shrink-0 px-3 py-1.5 bg-amber-600 text-white text-xs font-semibold rounded-lg hover:bg-amber-700 disabled:opacity-50 transition-all">
                  {dismissing === alert.id ? '...' : 'Dismiss'}
                </button>
              </div>
            </div>
          ))}
          {alerts.length === 0 && (
            <div className="text-center py-8 text-gray-400">
              <p className="text-2xl mb-2">✓</p>
              <p className="text-sm">All caught up — no pending reviews.</p>
            </div>
          )}
        </div>
        <div className="p-4 border-t border-gray-200 flex-shrink-0">
          <button onClick={onClose} className="w-full py-2.5 rounded-xl border border-gray-200 text-gray-600 font-semibold hover:bg-gray-50 text-sm">Close</button>
        </div>
      </div>
    </div>
  );
}
